import React from "react";
import { Link } from "react-router-dom";

function NotFound(props) {
  return (
    <div className="site-content pd-top-global-large d-flex justify-content-center flex-column">
      <div className="container text-align-center"><h1>Page Not found</h1><br /> 
        <Link to="/" className="link-red">Go to home</Link> 
      </div>
    </div>
  );
}

// export default NotFound;
export default NotFound;
